/* eslint-disable prefer-template */
/* eslint-disable no-plusplus */
export const formatSalary = (salary: any) => {
  let salaryString = salary?.toString() || '';
  salaryString = salaryString.replace(/,/g, '');

  let formattedSalary = '';
  let count = 0;
  for (let i = salaryString.length - 1; i >= 0; i--) {
    count++;
    formattedSalary = salaryString.charAt(i) + formattedSalary;
    if ((count === 7 || count === 5 || count === 3) && i !== 0) {
      formattedSalary = ',' + formattedSalary;
    }
  }
  return formattedSalary;
};

export const removeCommas = (salaryWithCommas: any) => {
  if (!salaryWithCommas) {
    return salaryWithCommas;
  }
  if (salaryWithCommas.toString().includes(',')) {
    const sal = salaryWithCommas.replace(/,/g, '');
    return parseInt(sal, 10);
  }
  return salaryWithCommas;
};
